
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/villa-configurator",
      function () {
        return require("private-next-pages/villa-configurator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/villa-configurator"])
      });
    }
  